import "core-js/modules/es.array.push.js";
import { noticeList, threadList } from '@/api/mg';
export default {
  data: function data() {
    return {
      title: '',
      list: []
    };
  },
  created: function created() {
    this.title = this.$route.query.str;
    if (this.title === 'Likes') {
      this.getNoticeList({
        page: 1,
        perPage: 1000,
        'filter[type]': 'liked'
      });
      return;
    }
    if (this.title === 'Comments') {
      this.getNoticeList({
        page: 1,
        perPage: 1000,
        'filter[type]': 'replied'
      });
      return;
    }
    if (this.title === 'Dynamic') {
      this.getThreadList({
        perPage: 1000,
        page: 1,
        'filter[attention]': 1
      });
      return;
    }
    this.getNoticeList({
      page: 1,
      perPage: 1000,
      'filter[type]': this.title
    });
  },
  methods: {
    getThreadList: function getThreadList(params) {
      var _this = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          _this.list = res.Data.pageData;
          if (_this.list.length === 0) {
            _this.$toast('No Data');
          }
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toDetail: function toDetail(threadId, categoryName) {
      console.log(threadId, categoryName);
      this.$router.push({
        path: '/social/detail',
        query: {
          from: categoryName.toLowerCase(),
          threadId: threadId
        }
      });
    },
    getNoticeList: function getNoticeList(params) {
      var _this2 = this;
      noticeList(params).then(function (res) {
        if (res.Code === 0) {
          _this2.list = res.Data.pageData;
          if (_this2.list.length === 0) {
            _this2.$toast('No Data');
          }
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    back: function back() {
      this.$router.back();
    }
  }
};